// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"db23be3c","57":"8490d128","124":"2e9301af","353":"496a5887","449":"5243685d","453":"87e45203","648":"57f92a4c","660":"dff304d2","697":"67530aa1","712":"28489738","819":"23146a18"}[chunkId] + ".chunk.js";
};